import { action } from 'typesafe-actions';
import keyBy from 'lodash/keyBy';

import * as Types from 'types';
import { receiveArtworks } from 'features/artworks/actions';

import { EditionsActionTypes } from './types';
import { requestCurrentUserEditions, requestEdition } from './api';

export const requestEditions = () => action(EditionsActionTypes.REQUEST_EDITIONS);

export const resetEditions = (editions: Types.Edition[]) =>
  action(EditionsActionTypes.RESET_EDITIONS, keyBy(editions, 'id'));

export const setEditions = (editions: Types.Edition[]) =>
  action(EditionsActionTypes.SET_EDITIONS, keyBy(editions, 'id'));

export const showGiftEdition = (editionId?: number) =>
  action(EditionsActionTypes.SHOW_GIFT_EDITION, editionId);

export const Actions = {
  requestEditions,
  setEditions,
  resetEditions,
  showGiftEdition,
};

/**
 * Fetches current user editions.
 */
export const fetchEditions = (): Types.DefaultThunkAction => async (dispatch) => {
  dispatch(requestEditions());
  const { editions, artworks } = await requestCurrentUserEditions();
  dispatch(receiveArtworks(artworks));
  dispatch(resetEditions(editions));
};

export const fetchEdition =
  (editionId: number): Types.DefaultThunkAction<Promise<Types.Edition | undefined>> =>
  async (dispatch) => {
    try {
      const edition = await requestEdition(editionId);
      dispatch(setEditions([edition]));
      return edition;
    } catch {
      return undefined;
    }
  };
